import Content from 'modules/template-editor/ui/components/editor/main-window/content';
import Header from 'modules/template-editor/ui/components/editor/main-window/header';
import LeftToolbar from 'modules/template-editor/ui/components/editor/left-toolbar/left-toolbar';
import React from 'react';
import RightToolbar from 'modules/template-editor/ui/components/editor/right-toolbar/right-toolbar';
import styled from '@emotion/styled';
import { useFetchOrganizer } from 'modules/organizer/ui/hooks/use-fetch-organizer';
import { useLoadTemplates } from '../hooks/use-load-templates';

const BoardEditor = () => {
  useLoadTemplates();
  useFetchOrganizer();

  return (
    <MainBlock>
      <Header />
      <ContentWrapper>
        <LeftToolbar />
        <Content />
        <RightToolbar />
      </ContentWrapper>
    </MainBlock>
  );
};

export default BoardEditor;

const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  display: flex;
  height: 100%;

  overflow: hidden;
`;
